import Link from 'next/link';
import Logo from '@/components/common/Logo';
import RecentCalculators from '@/components/common/RecentCalculators';

export default function Footer() {
    return (
        <footer className="bg-gray-100 border-t border-gray-300 py-8 mt-12">
            <div className="max-w-6xl mx-auto px-4">
                <div className="mb-6">
                    <Logo size="md" />
                    <p className="text-sm text-gray-600 mt-2">
                        Free calculators for everyday American life decisions.
                    </p>
                </div>

                {/* Recently used calculators */}
                <RecentCalculators limit={5} title="Recently Used" />

                {/* Simple link list */}
                <div className="mb-6">
                    <h3 className="font-bold text-sm mb-2">Popular Calculators</h3>
                    <div className="space-y-1 text-sm">
                        <Link href="/calculators/mortgage" className="block text-blue-600 hover:underline">
                            Mortgage Calculator
                        </Link>
                        <Link href="/calculators/401k" className="block text-blue-600 hover:underline">
                            401(k) Calculator
                        </Link>
                        <Link href="/calculators/retirement" className="block text-blue-600 hover:underline">
                            Retirement Calculator
                        </Link>
                        <Link href="/calculators/auto-loan" className="block text-blue-600 hover:underline">
                            Auto Loan Calculator
                        </Link>
                        <Link href="/calculators/salary" className="block text-blue-600 hover:underline">
                            Salary Calculator
                        </Link>
                    </div>
                </div>

                {/* Legal links */}
                <div className="border-t border-gray-300 pt-4 mb-4">
                    <div className="flex flex-wrap gap-x-3 gap-y-1 text-sm">
                        <Link href="/privacy-policy" className="text-blue-600 hover:underline">
                            privacy policy
                        </Link>
                        <span className="text-gray-400">|</span>
                        <Link href="/terms-of-service" className="text-blue-600 hover:underline">
                            terms of service
                        </Link>
                        <span className="text-gray-400">|</span>
                        <Link href="/contact" className="text-blue-600 hover:underline">
                            contact
                        </Link>
                    </div>
                </div>

                {/* Disclaimers - simple text boxes */}
                <div className="space-y-4 text-xs text-gray-600">
                    <div className="bg-yellow-50 border border-yellow-200 p-3">
                        <p className="font-bold mb-1">Affiliate Disclosure:</p>
                        <p>Some links are affiliate links. We may earn a commission at no extra cost to you. This helps keep our calculators free.</p>
                    </div>

                    <div className="bg-gray-50 border border-gray-300 p-3">
                        <p className="font-bold mb-1">Disclaimer:</p>
                        <p>For educational purposes only. Results are estimates. Not professional advice. Consult qualified professionals before making important decisions. Use at your own risk.</p>
                    </div>
                </div>

                <div className="border-t border-gray-300 pt-4 mt-6 text-xs text-gray-600">
                    <p>© 2026 American Calculators. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}